// extracted by mini-css-extract-plugin
export default {"resumeKey":"zReports_resumeKey__69uTk","icon":"zReports_icon__sDNXg"};